import {get, post} from './Api';

export function SearchRegister(params) {
    return get({url: '/api/v1/haire/member/search/'+params});
}

export function CreateMember({data}) {
    return post({url: '/api/v1/haire/register/member/create', data})
}

export function SearchShopCode(shopCode) {
    return get({url: '/api/v1/haire/shop/search/'+shopCode})
}

export function CreateEmployee({data}) {
    return post({url: '/api/v1/haire/register/employee/create', data})
}
